export const IDLE = 'IDLE';
export const LOADING = 'LOADING';
export const REFRESHING = 'REFRESHING';
export const PARTIAL = 'PARTIAL';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const SAVING = 'SAVING';
